import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/About.css";

export default function About() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t("about.helmetTitle")} - Alfasol`;
  }, [t]);

  /*const teamMembers = [
    {
      nameKey: "about.team.member1.name",
      roleKey: "about.team.member1.role",
      bioKey: "about.team.member1.bio"
    },
    {
      nameKey: "about.team.member2.name",
      roleKey: "about.team.member2.role",
      bioKey: "about.team.member2.bio"
    }
  ];*/

  return (
    <div className="aboutus-container">
      <h1>{t("about.title")}</h1>

      <section>
        <h2>{t("about.section1.title")}</h2>
        <p>{t("about.section1.text")}</p>
      </section>

      <section>
        <h2>{t("about.section2.title")}</h2>
        <p>{t("about.section2.text")}</p>
      </section>

      <section>
        <h2>{t("about.section3.title")}</h2>
        <p>{t("about.section3.text")}</p>
      </section>

      <section>
        <h2>{t("about.section4.title")}</h2>
        <p>{t("about.section4.text")}</p>

        {/* <div className="team-container">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <h3>{t(member.nameKey)}</h3>
              <h4>{t(member.roleKey)}</h4>
              <p>{t(member.bioKey)}</p>
            </div>
          ))}
        </div> */}
      </section>

      <section>
        <h2>{t("about.section5.title")}</h2>
        <p>{t("about.section5.text")}</p>
      </section>
    </div>
  );
}